import React, { useState, useEffect } from 'react';
import {
    Table,
    Button,
    Modal,
    Form,
    Input,
    Typography,
    Divider,
    message,
    Row,
    Col,
    Space,
} from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import Header from '../components/Header';
import { createRunwayAccount, createMiniMaxAccount } from '../services/api';
import { useNavigate } from 'react-router-dom';
const API_URL = process.env.REACT_APP_API_URL;

const { Title } = Typography;

const AdminPage = () => {
    const [accounts, setAccounts] = useState([]);
    const [form] = Form.useForm();
    const [selectedUserAI, setSelectedUserAI] = useState(null);
    const [isModalAIVisible, setIsModalAIVisible] = useState(false);
    const [saving, setSaving] = useState(false);
    const navigate = useNavigate();

    const loadAccounts = async () => {
        try {
            const res = await axios.get(`${API_URL}/auth/account`);
            const currentUser = JSON.parse(
                localStorage.getItem('account_web') || 'null',
            );
            const filtered = res.data.filter(
                (acc) => acc.id !== currentUser?.id,
            );
            setAccounts(filtered);
        } catch (err) {
            message.error('Lỗi khi tải danh sách tài khoản người dùng');
        }
    };

    useEffect(() => {
        loadAccounts();
    }, []);

    const handleUpdate = async (ownerId, values) => {
        setSaving(true);
        try {
            if (values.email && values.password) {
                const runway = await createRunwayAccount(
                    values.email,
                    values.password,
                );
                await axios.post(`${API_URL}/accounts`, {
                    provider: 'runway',
                    email: values.email,
                    password: values.password,
                    ownerId,
                });
            }

            if (values.minimax_url && values.minimax_token) {
                const minimax = await createMiniMaxAccount(
                    values.minimax_url,
                    values.minimax_token,
                );
                const displayName = minimax?.jwt?.user?.name || minimax.account;
                await axios.post(`${API_URL}/accounts`, {
                    provider: 'hailuo',
                    accountId: minimax.account,
                    name: displayName,
                    ownerId,
                });
            }

            message.success('Cập nhật tài khoản AI thành công');
            loadAccounts();
        } catch (err) {
            console.error('❌ Lỗi:', err);
            message.error(
                err.response?.data?.message || 'Cập nhật tài khoản AI thất bại',
            );
        } finally {
            setSaving(false);
        }
    };

    const handleDelete = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xoá',
            content:
                'Bạn có chắc muốn xoá tài khoản này? Toàn bộ AI sẽ bị xoá.',
            onOk: async () => {
                try {
                    await axios.delete(`${API_URL}/api/account-web/${id}`);
                    message.success('Xoá tài khoản thành công');
                    loadAccounts();
                } catch (err) {
                    message.error('Lỗi khi xoá tài khoản');
                }
            },
        });
    };

    const handleViewAI = async (userId) => {
        try {
            const res = await axios.get(`${API_URL}/accounts/owner/${userId}`);
            setSelectedUserAI(res.data);
        } catch (err) {
            message.error('Không thể tải danh sách tài khoản AI');
            setSelectedUserAI([]);
        } finally {
            setIsModalAIVisible(true);
        }
    };

    const handleDeleteAIAccount = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xoá',
            content: 'Bạn có chắc muốn xoá tài khoản AI này?',
            onOk: async () => {
                try {
                    await axios.delete(`${API_URL}/accounts/${id}`);
                    message.success('Xoá tài khoản AI thành công');

                    setSelectedUserAI((prev) =>
                        prev.filter((item) => item.id !== id),
                    );
                } catch (err) {
                    message.error('Lỗi khi xoá tài khoản AI');
                }
            },
        });
    };

    return (
        <div>
            <Header />
            <div style={{ padding: 40 }}>
                <Title level={3}>
                    Quản lý tài khoản người dùng & tài khoản AI
                </Title>
                <Button type="link" onClick={() => navigate('/manage-ais')}>
                    Quản lý AI dùng chung
                </Button>
                <Button
                    onClick={() => window.history.back()}
                    style={{ marginBottom: 20 }}
                >
                    ← Quay lại
                </Button>

                <Table
                    dataSource={accounts}
                    rowKey="id"
                    expandable={{
                        expandedRowRender: (record) => (
                            <Form
                                layout="vertical"
                                onFinish={(values) =>
                                    handleUpdate(record.id, values)
                                }
                                initialValues={{
                                    email: '',
                                    password: '',
                                    minimax_url: '',
                                    minimax_token: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col span={12}>
                                        <Divider>Runway AI</Divider>
                                        <Form.Item
                                            name="email"
                                            label="Email"
                                            rules={[
                                                {
                                                    type: 'email',
                                                    message:
                                                        'Email không hợp lệ',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Nhập email Runway" />
                                        </Form.Item>
                                        <Form.Item
                                            name="password"
                                            label="Mật khẩu"
                                        >
                                            <Input.Password placeholder="Mật khẩu Runway (nếu có)" />
                                        </Form.Item>
                                    </Col>

                                    <Col span={12}>
                                        <Divider>Hailuo AI</Divider>
                                        <Form.Item
                                            name="minimax_url"
                                            label="Hailuo AI URL"
                                        >
                                            <Input placeholder="https://hailuoai.video/..." />
                                        </Form.Item>
                                        <Form.Item
                                            name="minimax_token"
                                            label="Token Hailuo AI"
                                        >
                                            <Input placeholder="Nhập token" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        block
                                        loading={saving}
                                    >
                                        Lưu cấu hình AI
                                    </Button>
                                </Form.Item>
                            </Form>
                        ),
                    }}
                    columns={[
                        {
                            title: 'Username',
                            dataIndex: 'username',
                        },
                        {
                            title: 'Email',
                            dataIndex: 'email',
                        },
                        {
                            title: 'Role',
                            dataIndex: 'role',
                            render: (role) => (role === 0 ? 'Admin' : 'User'),
                        },
                        {
                            title: 'Hành động',
                            key: 'action',
                            render: (_, record) => (
                                <Space>
                                    <Button
                                        icon={<DeleteOutlined />}
                                        danger
                                        onClick={() => handleDelete(record.id)}
                                    />
                                    <Button
                                        onClick={() => handleViewAI(record.id)}
                                    >
                                        Xem tài khoản AI
                                    </Button>
                                </Space>
                            ),
                        },
                    ]}
                />
            </div>

            <Modal
                title="Danh sách tài khoản AI"
                open={isModalAIVisible}
                onCancel={() => setIsModalAIVisible(false)}
                footer={null}
                width={1200}
            >
                {selectedUserAI && selectedUserAI.length > 0 ? (
                    <Table
                        dataSource={selectedUserAI}
                        rowKey={(record) => record.id}
                        size="small"
                        pagination={false}
                        columns={[
                            { title: 'ID', dataIndex: 'id' },
                            { title: 'Provider', dataIndex: 'provider' },
                            { title: 'Email', dataIndex: 'email' },
                            {
                                title: 'Password',
                                dataIndex: 'password',
                                render: () => '••••••••',
                            },
                            { title: 'Account ID', dataIndex: 'accountId' },
                            { title: 'Name', dataIndex: 'name' },
                            {
                                title: 'Created At',
                                dataIndex: 'createdAt',
                                render: (text) =>
                                    new Date(text).toLocaleString('vi-VN', {
                                        day: '2-digit',
                                        month: '2-digit',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        second: '2-digit',
                                        timeZone: 'Asia/Ho_Chi_Minh',
                                    }),
                            },
                            { title: 'Owner ID', dataIndex: 'ownerId' },
                            {
                                title: 'Hành động',
                                render: (_, record) => (
                                    <Button
                                        icon={<DeleteOutlined />}
                                        danger
                                        size="small"
                                        onClick={() =>
                                            handleDeleteAIAccount(record.id)
                                        }
                                    >
                                        Xoá
                                    </Button>
                                ),
                            },
                        ]}
                    />
                ) : (
                    <p>Không có tài khoản AI nào cho người dùng này.</p>
                )}
            </Modal>
        </div>
    );
};

export default AdminPage;
